import styled from "styled-components";

export const SyncQuizContainer = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 2px;
  left: 6px;
  font-weight: 500;
  font-size: var(--sm-font-size);
  color: #fcae32;
`;

export const SyncQuizIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => (props.color ? props.color : "white")};
  border: solid 1px #432666;
  border-radius: 4px;
  margin: 5px;
  transition: all 0.3s;
  color: white;
`;
